var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmall2 = function SvgSmall2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 278,
    viewBox: "0 0 320 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 268,
    height: 226,
    rx: 15,
    fill: "#28263D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#5F4EEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4EA2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#7BD35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.337 48.7306L126.113 36.4777",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.771 58.3975C148.733 53.3994 155.945 49.9139 162.63 46",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.971 53.2884C109.068 51.1625 106.736 48.2632 103.986 45.936C99.904 42.4824 95.68 39.5435 91 37",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.479 77.2466C100.683 78.884 95.7587 80.7912 91.5219 83.6108C89.7351 84.7999 87.5876 86.2114 86.4377 88.0364",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.019 88.2576C113.159 91.7664 109.709 95.1996 108.024 99.287",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.99 64.0443C99.0815 63.5842 94.1397 63.5262 89.22 63.3808",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EFCC4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EF6B4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EF4E61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2006_4329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 56,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#C54EEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 56.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#63617C"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 114,
    width: 231,
    height: 30,
    rx: 15,
    fill: "#4F4D67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.352 128.876V125.292H62.228C63.684 125.292 64.3 125.964 64.3 127.098C64.3 128.19 63.684 128.876 62.228 128.876H60.352ZM65.602 127.098C65.602 125.502 64.524 124.242 62.228 124.242H59.078V134H60.352V129.926H62.228C64.65 129.926 65.602 128.582 65.602 127.098ZM68.4594 129.828C68.4594 128.05 69.3834 127.504 70.6014 127.504H70.9374V126.188C69.7194 126.188 68.8934 126.72 68.4594 127.574V126.328H67.1854V134H68.4594V129.828ZM79.6881 130.15C79.6881 127.728 77.9941 126.202 75.8101 126.202C73.6401 126.202 71.9321 127.728 71.9321 130.15C71.9321 132.586 73.5841 134.126 75.7541 134.126C77.9381 134.126 79.6881 132.586 79.6881 130.15ZM73.2341 130.15C73.2341 128.218 74.4521 127.308 75.7961 127.308C77.1121 127.308 78.3861 128.218 78.3861 130.15C78.3861 132.096 77.0841 133.006 75.7541 133.006C74.4241 133.006 73.2341 132.096 73.2341 130.15ZM81.6432 131.9C81.6432 133.44 82.4132 134 83.7712 134H84.9192V132.922H83.9812C83.1972 132.922 82.9172 132.656 82.9172 131.9V127.378H84.9192V126.328H82.9172V124.396H81.6432V126.328H80.6492V127.378H81.6432V131.9ZM89.7248 127.28C91.0408 127.28 92.1608 128.106 92.1468 129.604H87.3028C87.4428 128.106 88.4788 127.28 89.7248 127.28ZM93.3088 131.634H91.9368C91.6568 132.46 90.9288 133.048 89.7808 133.048C88.4788 133.048 87.3868 132.194 87.2888 130.64H93.4208C93.4488 130.374 93.4628 130.15 93.4628 129.87C93.4628 127.77 92.0068 126.202 89.7808 126.202C87.5408 126.202 85.9868 127.728 85.9868 130.15C85.9868 132.586 87.5968 134.126 89.7808 134.126C91.6848 134.126 92.9168 133.034 93.3088 131.634ZM94.6684 130.15C94.6684 132.586 96.2224 134.126 98.4064 134.126C100.31 134.126 101.556 133.062 101.948 131.536H100.576C100.296 132.502 99.5404 133.048 98.4064 133.048C97.0064 133.048 95.9704 132.054 95.9704 130.15C95.9704 128.274 97.0064 127.28 98.4064 127.28C99.5404 127.28 100.31 127.868 100.576 128.792H101.948C101.556 127.182 100.31 126.202 98.4064 126.202C96.2224 126.202 94.6684 127.742 94.6684 130.15ZM103.928 131.9C103.928 133.44 104.698 134 106.056 134H107.204V132.922H106.266C105.482 132.922 105.202 132.656 105.202 131.9V127.378H107.204V126.328H105.202V124.396H103.928V126.328H102.934V127.378H103.928V131.9ZM112.01 127.28C113.326 127.28 114.446 128.106 114.432 129.604H109.588C109.728 128.106 110.764 127.28 112.01 127.28ZM115.594 131.634H114.222C113.942 132.46 113.214 133.048 112.066 133.048C110.764 133.048 109.672 132.194 109.574 130.64H115.706C115.734 130.374 115.748 130.15 115.748 129.87C115.748 127.77 114.292 126.202 112.066 126.202C109.826 126.202 108.272 127.728 108.272 130.15C108.272 132.586 109.882 134.126 112.066 134.126C113.97 134.126 115.202 133.034 115.594 131.634ZM116.954 130.136C116.954 132.516 118.536 134.126 120.594 134.126C121.994 134.126 122.988 133.412 123.45 132.558V134H124.738V123.64H123.45V127.7C122.918 126.818 121.812 126.202 120.608 126.202C118.536 126.202 116.954 127.742 116.954 130.136ZM123.45 130.15C123.45 131.956 122.246 133.006 120.846 133.006C119.446 133.006 118.256 131.942 118.256 130.136C118.256 128.33 119.446 127.308 120.846 127.308C122.246 127.308 123.45 128.372 123.45 130.15Z",
    fill: "#ECEDF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 119.9,
    width: 38.2,
    height: 18.2,
    rx: 9.1,
    fill: "#8B8EA9",
    stroke: "#4F4D67",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 119.9,
    width: 18.2,
    height: 18.2,
    rx: 9.1,
    fill: "#ECEDF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 119.9,
    width: 18.2,
    height: 18.2,
    rx: 9.1,
    stroke: "#4F4D67",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68 163.34V160.78H47.02C48.06 160.78 48.5 161.26 48.5 162.07C48.5 162.85 48.06 163.34 47.02 163.34H45.68ZM49.43 162.07C49.43 160.93 48.66 160.03 47.02 160.03H44.77V167H45.68V164.09H47.02C48.75 164.09 49.43 163.13 49.43 162.07ZM51.471 164.02C51.471 162.75 52.131 162.36 53.001 162.36H53.241V161.42C52.371 161.42 51.781 161.8 51.471 162.41V161.52H50.561V167H51.471V164.02ZM59.4915 164.25C59.4915 162.52 58.2815 161.43 56.7215 161.43C55.1715 161.43 53.9515 162.52 53.9515 164.25C53.9515 165.99 55.1315 167.09 56.6815 167.09C58.2415 167.09 59.4915 165.99 59.4915 164.25ZM54.8815 164.25C54.8815 162.87 55.7515 162.22 56.7115 162.22C57.6515 162.22 58.5615 162.87 58.5615 164.25C58.5615 165.64 57.6315 166.29 56.6815 166.29C55.7315 166.29 54.8815 165.64 54.8815 164.25ZM60.888 165.5C60.888 166.6 61.438 167 62.408 167H63.228V166.23H62.558C61.998 166.23 61.798 166.04 61.798 165.5V162.27H63.228V161.52H61.798V160.14H60.888V161.52H60.178V162.27H60.888V165.5ZM66.6605 162.2C67.6005 162.2 68.4005 162.79 68.3905 163.86H64.9305C65.0305 162.79 65.7705 162.2 66.6605 162.2ZM69.2205 165.31H68.2405C68.0405 165.9 67.5205 166.32 66.7005 166.32C65.7705 166.32 64.9905 165.71 64.9205 164.6H69.3005C69.3205 164.41 69.3305 164.25 69.3305 164.05C69.3305 162.55 68.2905 161.43 66.7005 161.43C65.1005 161.43 63.9905 162.52 63.9905 164.25C63.9905 165.99 65.1405 167.09 66.7005 167.09C68.0605 167.09 68.9405 166.31 69.2205 165.31ZM70.1917 164.25C70.1917 165.99 71.3017 167.09 72.8617 167.09C74.2217 167.09 75.1117 166.33 75.3917 165.24H74.4117C74.2117 165.93 73.6717 166.32 72.8617 166.32C71.8617 166.32 71.1217 165.61 71.1217 164.25C71.1217 162.91 71.8617 162.2 72.8617 162.2C73.6717 162.2 74.2217 162.62 74.4117 163.28H75.3917C75.1117 162.13 74.2217 161.43 72.8617 161.43C71.3017 161.43 70.1917 162.53 70.1917 164.25ZM76.8059 165.5C76.8059 166.6 77.3559 167 78.3259 167H79.1459V166.23H78.4759C77.9159 166.23 77.7159 166.04 77.7159 165.5V162.27H79.1459V161.52H77.7159V160.14H76.8059V161.52H76.0959V162.27H76.8059V165.5ZM83.1145 165.5C83.1145 166.6 83.6645 167 84.6345 167H85.4545V166.23H84.7845C84.2245 166.23 84.0245 166.04 84.0245 165.5V162.27H85.4545V161.52H84.0245V160.14H83.1145V161.52H82.4045V162.27H83.1145V165.5ZM86.5571 167H87.4671V163.97C87.4671 162.79 88.1071 162.21 89.0371 162.21C89.9571 162.21 90.5671 162.78 90.5671 163.9V167H91.4671V163.77C91.4671 162.2 90.4971 161.42 89.2771 161.42C88.5071 161.42 87.8271 161.73 87.4671 162.31V159.6H86.5571V167ZM92.9536 167H93.8636V161.52H92.9536V167ZM93.4236 160.63C93.7536 160.63 94.0236 160.36 94.0236 160.01C94.0236 159.66 93.7536 159.39 93.4236 159.39C93.0736 159.39 92.8036 159.66 92.8036 160.01C92.8036 160.36 93.0736 160.63 93.4236 160.63ZM99.3545 165.51C99.3145 163.55 96.1345 164.26 96.1345 162.96C96.1345 162.52 96.5345 162.2 97.2045 162.2C97.9345 162.2 98.3545 162.6 98.3945 163.15H99.3045C99.2445 162.08 98.4445 161.43 97.2345 161.43C96.0145 161.43 95.2245 162.12 95.2245 162.96C95.2245 165 98.4645 164.29 98.4645 165.51C98.4645 165.96 98.0645 166.32 97.3445 166.32C96.5745 166.32 96.1045 165.92 96.0545 165.39H95.1145C95.1745 166.39 96.0745 167.09 97.3545 167.09C98.5645 167.09 99.3545 166.41 99.3545 165.51ZM102.965 164.24C102.965 165.94 104.095 167.09 105.565 167.09C106.565 167.09 107.275 166.58 107.605 165.97V167H108.525V159.6H107.605V162.5C107.225 161.87 106.435 161.43 105.575 161.43C104.095 161.43 102.965 162.53 102.965 164.24ZM107.605 164.25C107.605 165.54 106.745 166.29 105.745 166.29C104.745 166.29 103.895 165.53 103.895 164.24C103.895 162.95 104.745 162.22 105.745 162.22C106.745 162.22 107.605 162.98 107.605 164.25ZM115.263 164.25C115.263 162.52 114.053 161.43 112.493 161.43C110.943 161.43 109.723 162.52 109.723 164.25C109.723 165.99 110.903 167.09 112.453 167.09C114.013 167.09 115.263 165.99 115.263 164.25ZM110.653 164.25C110.653 162.87 111.523 162.22 112.483 162.22C113.423 162.22 114.333 162.87 114.333 164.25C114.333 165.64 113.403 166.29 112.453 166.29C111.503 166.29 110.653 165.64 110.653 164.25ZM116.119 164.25C116.119 165.99 117.229 167.09 118.789 167.09C120.149 167.09 121.039 166.33 121.319 165.24H120.339C120.139 165.93 119.599 166.32 118.789 166.32C117.789 166.32 117.049 165.61 117.049 164.25C117.049 162.91 117.789 162.2 118.789 162.2C119.599 162.2 120.149 162.62 120.339 163.28H121.319C121.039 162.13 120.149 161.43 118.789 161.43C117.229 161.43 116.119 162.53 116.119 164.25ZM127.394 161.52H126.484V164.53C126.484 165.71 125.854 166.29 124.914 166.29C123.994 166.29 123.384 165.72 123.384 164.61V161.52H122.484V164.73C122.484 166.3 123.474 167.08 124.734 167.08C125.464 167.08 126.134 166.76 126.484 166.19V167H127.394V161.52ZM136.84 167H137.74V163.77C137.74 162.2 136.77 161.42 135.52 161.42C134.68 161.42 133.9 161.85 133.58 162.64C133.22 161.82 132.47 161.42 131.57 161.42C130.85 161.42 130.2 161.73 129.84 162.31V161.52H128.93V167H129.84V163.98C129.84 162.8 130.47 162.21 131.39 162.21C132.29 162.21 132.89 162.78 132.89 163.9V167H133.79V163.98C133.79 162.8 134.42 162.21 135.34 162.21C136.24 162.21 136.84 162.78 136.84 163.9V167ZM141.563 162.2C142.503 162.2 143.303 162.79 143.293 163.86H139.833C139.933 162.79 140.673 162.2 141.563 162.2ZM144.123 165.31H143.143C142.943 165.9 142.423 166.32 141.603 166.32C140.673 166.32 139.893 165.71 139.823 164.6H144.203C144.223 164.41 144.233 164.25 144.233 164.05C144.233 162.55 143.193 161.43 141.603 161.43C140.003 161.43 138.893 162.52 138.893 164.25C138.893 165.99 140.043 167.09 141.603 167.09C142.963 167.09 143.843 166.31 144.123 165.31ZM149.444 167H150.344V163.77C150.344 162.2 149.374 161.42 148.104 161.42C147.364 161.42 146.704 161.73 146.344 162.3V161.52H145.434V167H146.344V163.97C146.344 162.79 146.984 162.21 147.914 162.21C148.834 162.21 149.444 162.78 149.444 163.9V167ZM152.031 165.5C152.031 166.6 152.581 167 153.551 167H154.371V166.23H153.701C153.141 166.23 152.941 166.04 152.941 165.5V162.27H154.371V161.52H152.941V160.14H152.031V161.52H151.321V162.27H152.031V165.5ZM159.209 167H160.149L161.469 162.65L162.789 167H163.729L165.439 161.52H164.539L163.299 166.13L161.969 161.52H161.039L159.679 166.12L158.419 161.52H157.489L159.209 167ZM166.342 167H167.252V161.52H166.342V167ZM166.812 160.63C167.142 160.63 167.412 160.36 167.412 160.01C167.412 159.66 167.142 159.39 166.812 159.39C166.462 159.39 166.192 159.66 166.192 160.01C166.192 160.36 166.462 160.63 166.812 160.63ZM169.003 165.5C169.003 166.6 169.553 167 170.523 167H171.343V166.23H170.673C170.113 166.23 169.913 166.04 169.913 165.5V162.27H171.343V161.52H169.913V160.14H169.003V161.52H168.293V162.27H169.003V165.5ZM172.446 167H173.356V163.97C173.356 162.79 173.996 162.21 174.926 162.21C175.846 162.21 176.456 162.78 176.456 163.9V167H177.356V163.77C177.356 162.2 176.386 161.42 175.166 161.42C174.396 161.42 173.716 161.73 173.356 162.31V159.6H172.446V167ZM181.168 164.24C181.168 165.94 182.298 167.09 183.758 167.09C184.768 167.09 185.478 166.57 185.808 165.98V167H186.728V161.52H185.808V162.52C185.488 161.95 184.788 161.43 183.768 161.43C182.298 161.43 181.168 162.53 181.168 164.24ZM185.808 164.25C185.808 165.54 184.948 166.29 183.948 166.29C182.948 166.29 182.098 165.53 182.098 164.24C182.098 162.95 182.948 162.22 183.948 162.22C184.948 162.22 185.808 162.98 185.808 164.25ZM191.842 162.53V161.52H190.932V169.6H191.842V165.99C192.182 166.55 192.892 167.09 193.892 167.09C195.362 167.09 196.492 165.94 196.492 164.24C196.492 162.53 195.362 161.43 193.892 161.43C192.892 161.43 192.172 161.95 191.842 162.53ZM195.562 164.24C195.562 165.53 194.712 166.29 193.702 166.29C192.712 166.29 191.842 165.54 191.842 164.25C191.842 162.98 192.712 162.22 193.702 162.22C194.712 162.22 195.562 162.95 195.562 164.24ZM197.35 164.24C197.35 165.94 198.48 167.09 199.94 167.09C200.95 167.09 201.66 166.57 201.99 165.98V167H202.91V161.52H201.99V162.52C201.67 161.95 200.97 161.43 199.95 161.43C198.48 161.43 197.35 162.53 197.35 164.24ZM201.99 164.25C201.99 165.54 201.13 166.29 200.13 166.29C199.13 166.29 198.28 165.53 198.28 164.24C198.28 162.95 199.13 162.22 200.13 162.22C201.13 162.22 201.99 162.98 201.99 164.25ZM208.388 165.51C208.348 163.55 205.168 164.26 205.168 162.96C205.168 162.52 205.568 162.2 206.238 162.2C206.968 162.2 207.388 162.6 207.428 163.15H208.338C208.278 162.08 207.478 161.43 206.268 161.43C205.048 161.43 204.258 162.12 204.258 162.96C204.258 165 207.498 164.29 207.498 165.51C207.498 165.96 207.098 166.32 206.378 166.32C205.608 166.32 205.138 165.92 205.088 165.39H204.148C204.208 166.39 205.108 167.09 206.388 167.09C207.598 167.09 208.388 166.41 208.388 165.51ZM213.612 165.51C213.572 163.55 210.392 164.26 210.392 162.96C210.392 162.52 210.792 162.2 211.462 162.2C212.192 162.2 212.612 162.6 212.652 163.15H213.562C213.502 162.08 212.702 161.43 211.492 161.43C210.272 161.43 209.482 162.12 209.482 162.96C209.482 165 212.722 164.29 212.722 165.51C212.722 165.96 212.322 166.32 211.602 166.32C210.832 166.32 210.362 165.92 210.312 165.39H209.372C209.432 166.39 210.332 167.09 211.612 167.09C212.822 167.09 213.612 166.41 213.612 165.51ZM215.967 167H216.907L218.227 162.65L219.547 167H220.487L222.197 161.52H221.297L220.057 166.13L218.727 161.52H217.797L216.437 166.12L215.177 161.52H214.247L215.967 167ZM228.3 164.25C228.3 162.52 227.09 161.43 225.53 161.43C223.98 161.43 222.76 162.52 222.76 164.25C222.76 165.99 223.94 167.09 225.49 167.09C227.05 167.09 228.3 165.99 228.3 164.25ZM223.69 164.25C223.69 162.87 224.56 162.22 225.52 162.22C226.46 162.22 227.37 162.87 227.37 164.25C227.37 165.64 226.44 166.29 225.49 166.29C224.54 166.29 223.69 165.64 223.69 164.25ZM230.407 164.02C230.407 162.75 231.067 162.36 231.937 162.36H232.177V161.42C231.307 161.42 230.717 161.8 230.407 162.41V161.52H229.497V167H230.407V164.02ZM232.887 164.24C232.887 165.94 234.017 167.09 235.487 167.09C236.487 167.09 237.197 166.58 237.527 165.97V167H238.447V159.6H237.527V162.5C237.147 161.87 236.357 161.43 235.497 161.43C234.017 161.43 232.887 162.53 232.887 164.24ZM237.527 164.25C237.527 165.54 236.667 166.29 235.667 166.29C234.667 166.29 233.817 165.53 233.817 164.24C233.817 162.95 234.667 162.22 235.667 162.22C236.667 162.22 237.527 162.98 237.527 164.25Z",
    fill: "#8B8EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 214C62.7348 214 62.4804 214.105 62.2929 214.293C62.1054 214.48 62 214.735 62 215V219C62 219.265 61.8946 219.52 61.7071 219.707C61.5196 219.895 61.2652 220 61 220H47C46.7348 220 46.4804 219.895 46.2929 219.707C46.1054 219.52 46 219.265 46 219V215C46 214.735 45.8946 214.48 45.7071 214.293C45.5196 214.105 45.2652 214 45 214C44.7348 214 44.4804 214.105 44.2929 214.293C44.1054 214.48 44 214.735 44 215V219C44 219.796 44.3161 220.559 44.8787 221.121C45.4413 221.684 46.2044 222 47 222H61C61.7956 222 62.5587 221.684 63.1213 221.121C63.6839 220.559 64 219.796 64 219V215C64 214.735 63.8946 214.48 63.7071 214.293C63.5196 214.105 63.2652 214 63 214ZM53.29 215.71C53.3851 215.801 53.4972 215.872 53.62 215.92C53.7397 215.973 53.8691 216 54 216C54.1309 216 54.2603 215.973 54.38 215.92C54.5028 215.872 54.6149 215.801 54.71 215.71L58.71 211.71C58.8983 211.522 59.0041 211.266 59.0041 211C59.0041 210.734 58.8983 210.478 58.71 210.29C58.5217 210.102 58.2663 209.996 58 209.996C57.7337 209.996 57.4783 210.102 57.29 210.29L55 212.59V203C55 202.735 54.8946 202.48 54.7071 202.293C54.5196 202.105 54.2652 202 54 202C53.7348 202 53.4804 202.105 53.2929 202.293C53.1054 202.48 53 202.735 53 203V212.59L50.71 210.29C50.6168 210.197 50.5061 210.123 50.3842 210.072C50.2624 210.022 50.1319 209.996 50 209.996C49.8681 209.996 49.7376 210.022 49.6158 210.072C49.4939 210.123 49.3832 210.197 49.29 210.29C49.1968 210.383 49.1228 210.494 49.0723 210.616C49.0219 210.738 48.9959 210.868 48.9959 211C48.9959 211.132 49.0219 211.262 49.0723 211.384C49.1228 211.506 49.1968 211.617 49.29 211.71L53.29 215.71Z",
    fill: "#ECEDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.328 208.728H75.078V218.5H80.328V217.45H76.352V214.09H79.908V213.04H76.352V209.778H80.328V208.728ZM86.2597 218.5H87.7017L85.2237 214.622L87.6877 210.828H86.3577L84.6217 213.67L82.8017 210.828H81.3597L83.8377 214.692L81.3597 218.5H82.6897L84.4397 215.644L86.2597 218.5ZM90.229 212.242V210.828H88.955V222.14H90.229V217.086C90.705 217.87 91.699 218.626 93.099 218.626C95.157 218.626 96.739 217.016 96.739 214.636C96.739 212.242 95.157 210.702 93.099 210.702C91.699 210.702 90.691 211.43 90.229 212.242ZM95.437 214.636C95.437 216.442 94.247 217.506 92.833 217.506C91.447 217.506 90.229 216.456 90.229 214.65C90.229 212.872 91.447 211.808 92.833 211.808C94.247 211.808 95.437 212.83 95.437 214.636ZM105.696 214.65C105.696 212.228 104.002 210.702 101.818 210.702C99.6479 210.702 97.9399 212.228 97.9399 214.65C97.9399 217.086 99.5919 218.626 101.762 218.626C103.946 218.626 105.696 217.086 105.696 214.65ZM99.2419 214.65C99.2419 212.718 100.46 211.808 101.804 211.808C103.12 211.808 104.394 212.718 104.394 214.65C104.394 216.596 103.092 217.506 101.762 217.506C100.432 217.506 99.2419 216.596 99.2419 214.65ZM108.645 214.328C108.645 212.55 109.569 212.004 110.787 212.004H111.123V210.688C109.905 210.688 109.079 211.22 108.645 212.074V210.828H107.371V218.5H108.645V214.328ZM112.874 216.4C112.874 217.94 113.644 218.5 115.002 218.5H116.15V217.422H115.212C114.428 217.422 114.148 217.156 114.148 216.4V211.878H116.15V210.828H114.148V208.896H112.874V210.828H111.88V211.878H112.874V216.4ZM120.95 214.636C120.95 217.016 122.532 218.626 124.576 218.626C125.99 218.626 126.984 217.898 127.446 217.072V218.5H128.734V210.828H127.446V212.228C126.998 211.43 126.018 210.702 124.59 210.702C122.532 210.702 120.95 212.242 120.95 214.636ZM127.446 214.65C127.446 216.456 126.242 217.506 124.842 217.506C123.442 217.506 122.252 216.442 122.252 214.636C122.252 212.83 123.442 211.808 124.842 211.808C126.242 211.808 127.446 212.872 127.446 214.65ZM136.403 216.414C136.347 213.67 131.895 214.664 131.895 212.844C131.895 212.228 132.455 211.78 133.393 211.78C134.415 211.78 135.003 212.34 135.059 213.11H136.333C136.249 211.612 135.129 210.702 133.435 210.702C131.727 210.702 130.621 211.668 130.621 212.844C130.621 215.7 135.157 214.706 135.157 216.414C135.157 217.044 134.597 217.548 133.589 217.548C132.511 217.548 131.853 216.988 131.783 216.246H130.467C130.551 217.646 131.811 218.626 133.603 218.626C135.297 218.626 136.403 217.674 136.403 216.414ZM143.179 217.716C143.179 217.226 142.801 216.848 142.339 216.848C141.849 216.848 141.471 217.226 141.471 217.716C141.471 218.206 141.849 218.584 142.339 218.584C142.801 218.584 143.179 218.206 143.179 217.716ZM155.947 218.5H157.207V213.978C157.207 211.78 155.849 210.688 154.099 210.688C152.923 210.688 151.831 211.29 151.383 212.396C150.879 211.248 149.829 210.688 148.569 210.688C147.561 210.688 146.651 211.122 146.147 211.934V210.828H144.873V218.5H146.147V214.272C146.147 212.62 147.029 211.794 148.317 211.794C149.577 211.794 150.417 212.592 150.417 214.16V218.5H151.677V214.272C151.677 212.62 152.559 211.794 153.847 211.794C155.107 211.794 155.947 212.592 155.947 214.16V218.5ZM158.821 214.636C158.821 217.016 160.403 218.626 162.461 218.626C163.861 218.626 164.855 217.912 165.317 217.058V218.5H166.605V208.14H165.317V212.2C164.785 211.318 163.679 210.702 162.475 210.702C160.403 210.702 158.821 212.242 158.821 214.636ZM165.317 214.65C165.317 216.456 164.113 217.506 162.713 217.506C161.313 217.506 160.123 216.442 160.123 214.636C160.123 212.83 161.313 211.808 162.713 211.808C164.113 211.808 165.317 212.872 165.317 214.65ZM172.728 218.5H174.002V211.878H175.612V210.828H174.002V210.282C174.002 209.288 174.38 208.868 175.528 208.868V207.804C173.568 207.804 172.728 208.574 172.728 210.282V210.828H171.734V211.878H172.728V218.5ZM177.098 218.5H178.372V210.828H177.098V218.5ZM177.756 209.582C178.218 209.582 178.596 209.204 178.596 208.714C178.596 208.224 178.218 207.846 177.756 207.846C177.266 207.846 176.888 208.224 176.888 208.714C176.888 209.204 177.266 209.582 177.756 209.582ZM180.543 218.5H181.817V208.14H180.543V218.5ZM187.25 211.78C188.566 211.78 189.686 212.606 189.672 214.104H184.828C184.968 212.606 186.004 211.78 187.25 211.78ZM190.834 216.134H189.462C189.182 216.96 188.454 217.548 187.306 217.548C186.004 217.548 184.912 216.694 184.814 215.14H190.946C190.974 214.874 190.988 214.65 190.988 214.37C190.988 212.27 189.532 210.702 187.306 210.702C185.066 210.702 183.512 212.228 183.512 214.65C183.512 217.086 185.122 218.626 187.306 218.626C189.21 218.626 190.442 217.534 190.834 216.134Z",
    fill: "#ECEDF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 266,
    height: 224,
    rx: 14,
    stroke: "#7666FF",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.613 131.445C178.023 122.308 172.869 108.738 168.518 102.825C164.166 96.9119 134.481 70.5776 131.402 67.3621C128.323 64.1466 121.534 68.4718 125.985 76.846C130.436 85.2201 130.975 86.1516 133.575 89.0845C136.175 92.0173 139.754 93.6578 141.28 95.7007C142.806 97.7437 145.003 102.455 148.509 106.566C152.015 110.677 154.663 112.715 155.578 115.022C156.492 117.33 154.988 119.793 156.918 125.163C158.848 130.533 161.758 135.29 163.703 138.489L181.613 131.445Z",
    fill: "#5BA0E0",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.009 140.122C168.772 141.583 165.908 140.393 164.531 139.507C164.217 139.307 163.964 139.024 163.801 138.69C163.637 138.355 163.569 137.982 163.604 137.611C163.804 135.67 165.02 131.76 171.294 129.71C176.047 128.157 179.102 129.241 180.744 130.298C181.198 130.58 181.524 131.028 181.654 131.547C181.783 132.066 181.704 132.615 181.435 133.078C180.213 135.068 177.525 138.562 173.009 140.122Z",
    fill: "#347DC1",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.619 66.4307L135.204 73.8594C136.001 74.7583 136.815 75.6724 137.842 76.2984C138.869 76.9245 140.161 77.2344 141.293 76.824",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.763 115.555C157.919 114.177 159.902 112.544 161.669 110.693",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.895 112.847C155.376 113.022 156.898 111.944 158.274 110.328",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.769 95.7777C143.414 94.6171 144.793 93.1194 145.815 91.3844",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.491 94.6755C141.348 94.1233 142.029 93.3362 142.453 92.408",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2006_4329",
    x: 0,
    y: 0,
    width: 320,
    height: 278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.463158 0 0 0 0 0.4 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2006_4329",
    x: 39,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.305882 0 0 0 0 0.937255 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2006_4329",
    x: 73,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.635294 0 0 0 0 0.937255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2006_4329",
    x: 80.4375,
    y: 30.4777,
    width: 88.1924,
    height: 74.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.305882 0 0 0 0 0.380392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2006_4329",
    x: 141,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.8 0 0 0 0 0.305882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2006_4329",
    x: 175,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.419608 0 0 0 0 0.305882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2006_4329",
    x: 209,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.305882 0 0 0 0 0.380392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2006_4329",
    x: 243,
    y: 51,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.305882 0 0 0 0 0.937255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2006_4329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2006_4329",
    result: "shape"
  })))));
};

export { SvgSmall2 as ReactComponent };
export default __webpack_public_path__ + "static/small2.27965400.svg";